<div
  class="max-w-[1400px] mx-auto"
  (tuiActiveZoneChange)="onZoneChange($event)"
>
  <div class="flex gap-2">
    <div class="w-3/12" tuiGroup [collapsed]="true">
      <tui-input-number [formControl]="form.controls.id" tuiTextfieldSize="m"
        >ID</tui-input-number
      >
      <app-input-date
        [formControl]="form.controls.creationDate"
        class="tui-group__inherit-item"
        label="Дата"
      ></app-input-date>
    </div>
    <div class="w-4/12" tuiGroup [collapsed]="true">
      <app-autocomplete
        [formControl]="form.controls.transportType"
        class="tui-group__inherit-item w-1/4 tui-group__auto-width-item"
        componentClass="tui-group__inherit-item"
        [items]="vehicles"
        [itemValue]="'value'"
        [itemText]="'name'"
        [displayValue]="'name'"
      >
      </app-autocomplete>
      <app-autocomplete
        [formControl]="form.controls.trailerType"
        class="tui-group__inherit-item w-3/4 tui-group__auto-width-item"
        componentClass="tui-group__inherit-item"
        [items]="cargoCatalogsService.trailersTypes$ | async"
        [itemValue]="'code'"
        [itemText]="'name'"
        [displayValue]="'name'"
      >
      </app-autocomplete>
    </div>
    <app-autocomplete
      class="w-2/12"
      [formControl]="form.controls.sellerJson.controls.id"
      [items]="sellers$ | async"
      [itemValue]="'id'"
      [itemText]="'name'"
      [displayValue]="'name'"
      [itemSearch]="'search'"
      (valueChanged)="fillSellerJson($event)"
    >
    </app-autocomplete>
    <div class="w-[150px]">
      <app-input-date
        [labelOutside]="false"
        label="Дата загрузки"
        [formControl]="form.controls.uploadDate"
      ></app-input-date>
    </div>
    <div class="w-[150px]">
      <app-input-date
        [labelOutside]="false"
        label="Дата выгрузки"
        [formControl]="form.controls.unloadDate"
      ></app-input-date>
    </div>
    <div>
      <button
        [disabled]="!(canMoveToCalculation$ | async)!"
        size="m"
        (click)="moveToCalculation$.next()"
        tuiButton
        appearance="accent"
      >
        Далее
      </button>
    </div>
  </div>
</div>
